export const getCookie = (key) => {
  const name = `${key}=`;
  const cookies = document.cookie.split(';');
  let newCookie;

  cookies.forEach((cookie) => {
    while (cookie.charAt(0) === ' ') {
      // eslint-disable-next-line no-param-reassign
      cookie = cookie.substring(1, cookie.length);
    }
    if (cookie.indexOf(name) === 0) {
      newCookie = decodeURIComponent(cookie.substring(name.length, cookie.length));
    }
  });

  return newCookie;
};

export const setCookie = (key, value, expireDays = 0, path = '/') => {
  const expireDate = new Date();
  let cookie = `${key}=${encodeURIComponent(value)}`;

  expireDate.setDate(expireDate.getDate() + expireDays);
  if (expireDays) {
    cookie += `;expires=${expireDate.toUTCString()}`;
  }
  if (path) {
    cookie += `;path=${path}`;
  }
  document.cookie = cookie;
};

export const deleteCookie = key => {
  document.cookie = key + '=; expires=Thu, 01 Jan 1970 00:00:01 UTC; path=/;';
};
